import QuarterService from '../../service/QuarterService';

const initialState = {
    quarters: []
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchQuarters({commit}) {
            try {
                const resp = await QuarterService.getQuarters()
                if (resp.status === 200) {
                    commit('setQuarters', resp.data.quarters)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async deleteQuarter({dispatch}, {quarterId}) {
            let isSuccessful = false;
            try {
                const resp = await QuarterService.deleteQuarter({quarterId})
                if (resp.status === 200) {
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Successfully saved',
                        type: 'success'
                    }, {root: true})
                    isSuccessful = true
                } else {
                    let message = 'Failed'

                    if (resp && resp.msg) {
                        message = resp.msg;
                    }

                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: message,
                        type: 'error'
                    }, {root: true})
                }
            } catch (e) {
                console.log(e)
            }

            return isSuccessful;
        },
        async saveQuarter({dispatch}, {quarterId, data}) {
            let isSuccessful = false;
            try {
                const resp = await QuarterService.saveQuarter({quarterId, data})
                if (resp.status === 200) {
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Successfully saved',
                        type: 'success'
                    }, {root: true})
                    isSuccessful = true
                } else {
                    let message = 'Failed'

                    if (resp && resp.msg) {
                        message = resp.msg;
                    }

                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: message,
                        type: 'error'
                    }, {root: true})
                }
            } catch (e) {
                console.log(e)
            }

            return isSuccessful
        },
    },
    mutations: {
        setQuarters(state, data) {
            state.quarters = data
        },
        addQuarter(state) {
            const id = `x-${Math.floor(Math.random() * (3000 - 1) + 1)}`

            state.quarters.push({
                id: id,
                quarter: null,
                start_date: null,
                countries: []
            })
        }
    },
    getters: {
    }
}